import { ResponseDTO } from "../../interfaces/response"
import { TransactionUserPostDto } from "../../interfaces/transaction"
import { TransactionServices } from "../services/TransactionServices"

export class TransactionController {

    private transactionServices = new TransactionServices()

    public async getTransactionsByUserId(
        requestBody: TransactionUserPostDto
    ): Promise<ResponseDTO> {
        const response = await this.transactionServices.getTransactionsByUserId(requestBody)
        return response
    }

    public async getTransactionsDownloadByBusinessId(
        businessId: number
    ): Promise<ResponseDTO> {
        const response = await this.transactionServices.getTransactionsDownloadByBusinessId(businessId)
        return response
    }
}